import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { disableScroll } from "../../../Actions/heatSpotAction";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import LiveChatBody from "./liveChat/liveChatBody";
import LiveChatFooter from "./liveChat/liveChatFooter";
import { updateVisitAction } from "../../../Actions/overviewActions";
import store from "../../../store";
import "./heatSpot.css";

class HeatSpotAppView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      liveChatInfoMessageBubbleIsOpen:
        JSON.parse(
          store.getState().loginResponse.results.BusinessUser.IsFirstVisit
        )["Curbside Communication Live Chat"] === 1,
    };
  }

  componentDidUpdate() {
    const { liveChatData } = this.props;
    if (liveChatData.scroll) {
      let scrollElement = document.getElementsByClassName("live-chat-panel");
      scrollElement &&
        (scrollElement[0].scrollTop =
          scrollElement[0].scrollHeight - scrollElement[0].clientHeight);
      this.props.disableScroll();
    }
  }

  liveChatStyles = () => {
    return {
      margin: this.state.liveChatInfoMessageBubbleIsOpen
        ? window.screen.width > 960
          ? "-149px 0px 0px 0px"
          : "-93px 0px 0px 0px"
        : "0px 0px 0px 0px",
    };
  };

  liveChatInfoMessageBubbleStyles = () => {
    return {
      display: this.state.liveChatInfoMessageBubbleIsOpen
        ? "inline-block"
        : "none",
      position: "relative",
      backgroundColor: `rgb(42, 0, 74)`,
      color: "#f5f5f9",
      height: "100%",
      width:
        window.screen.width > 2000
          ? "65%"
          : window.screen.width > 959
          ? "90%"
          : "65%",
      top: "-15px",
      left: window.screen.width > 959 ? "5%" : "20%",
      fontSize: "20px",
      zIndex: 1000,
      padding: "13px 20px 20px 20px",
    };
  };

  closeLiveChatInfoMessage = () => {
    const placeId = store.getState().loginResponse.results.BusinessUser.PlaceID;
    let visit = JSON.parse(
      store.getState().loginResponse.results.BusinessUser.IsFirstVisit
    );
    visit["Curbside Communication Live Chat"] = 0;
    this.props.updateVisitAction(placeId, JSON.stringify(visit));
    this.setState({
      liveChatInfoMessageBubbleIsOpen: false,
    });
  };

  render() {
    return (
      <React.Fragment>
        <div className="contactless-service-live-chat-message-wrapper">
          <Paper style={this.liveChatInfoMessageBubbleStyles()}>
            <IconButton
              style={{ color: "white", float: "right" }}
              onClick={this.closeLiveChatInfoMessage}
            >
              <CloseIcon />
            </IconButton>
            {
              "Post live updates for everyone to see when they arrive and check-in to your business."
            }
            <div className="contactless-service-liveChat-message-bubble-triangle" />
          </Paper>
        </div>
        <div style={this.liveChatStyles()}>
          <h1 className="app-header">Live Chat</h1>
          <h3 style={{ textAlign: "center" }}>
            {this.props.userDetails.AppUser.FirstName}
          </h3>
          <div className="live-chat-wrapper">
            <div className="live-chat-panel">
              {this.props.liveChatData && <LiveChatBody />}
            </div>
            <LiveChatFooter toggleAlert={this.props.toggleAlert} />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const matchDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      disableScroll,
      updateVisitAction,
    },
    dispatch
  );
};

export default connect(null, matchDispatchToProps)(HeatSpotAppView);
